// Internal route map for the Powered by DQ marketing site — mirrors the
// source design's *.dc.html page names, translated into app routes.
const PBDQ_BASE = '/powered-by-dq-exp';

const pbdqRoutes = {
    home: PBDQ_BASE,
    solutions: `${PBDQ_BASE}/solutions`,
    capabilities: `${PBDQ_BASE}/capabilities`,
    impact: `${PBDQ_BASE}/impact`,
    pricing: `${PBDQ_BASE}/pricing`,
    getStarted: `${PBDQ_BASE}/get-started`,
    cosAssessments: `${PBDQ_BASE}/cos-assessments`,
    schoolCosReadiness: `${PBDQ_BASE}/school-cos-readiness`,
    learnCreator: `${PBDQ_BASE}/learncreator`,
    workforceAiReadiness: `${PBDQ_BASE}/workforce-ai-readiness`,
    programValidation: `${PBDQ_BASE}/program-validation`,
    dqEveryChild: `${PBDQ_BASE}/dqeverychild`,
    chatbot: `${PBDQ_BASE}/chatbot`,
};

export default pbdqRoutes;
